import React, { createElement, ComponentType } from 'react';
import { Switch, Route, Redirect, BrowserRouter, RouteProps } from 'react-router-dom';

import { useUserState } from './context/UserContext';
import Login from './pages/Login/Login';
import Error from './pages/Error/Error';
import Recover from './pages/Recover/Recover';
import Offer from './pages/Offer/Offer';
import RootNavigation from 'navigation/RootNavigation';
import { AuthProvider } from 'context/AuthContext';

interface IRouteProps extends RouteProps {
  path: string;
  component: any;
}

function App() {
  const { isAuthenticated } = useUserState();

  const PrivateRoute: ComponentType<IRouteProps> = ({ component, ...rest }) => (
    <Route
      {...rest}
      // tslint:disable-next-line: jsx-no-lambda
      render={(props: any) =>
        isAuthenticated ? (
          createElement(component, props)
        ) : (
          <Redirect
            to={{
              pathname: '/iniciar-sesion',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );

  const PublicRoute: ComponentType<IRouteProps> = ({ component, path, ...rest }) => (
    <Route
      {...rest}
      // tslint:disable-next-line: jsx-no-lambda
      render={(props: any) =>
        isAuthenticated && path !== '/oferta/:id' ? ( // Permite acceso a la ruta "/oferta/:id" incluso si está autenticado
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        ) : (
          createElement(component, props)
        )
      }
    />
  );

  const redirectMainPath = () => <Redirect to="/app/inicio" />;

  return (
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" render={redirectMainPath} />
          <PrivateRoute path="/app" component={RootNavigation} />
          <PublicRoute path="/iniciar-sesion" component={Login} />
          <PublicRoute path="/recuperar" component={Recover} />
          <PublicRoute path="/oferta/:id" component={Offer} />
          <Route component={Error} />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
